module.exports = __FOREMAN_VENDOR__REACT_DND_HTML_5_BACKEND__;